import React from "react";
import {getManager} from "../../../../ts/manager/Manager";
import AccordionRouteView from "../../../route/AccordionRouteView";
import StateViewController from "../../../vc/StateViewController";
import {assert} from "../../../../ts/common/Assert";
import {IRouteProps} from "../../../../ts/manager/view/ViewInterface";
import NavRelatedPagesView from "../../../partial/nav/NavRelatedPagesView";
import {nbsp} from "../../../../ts/common/Constants";
import {JSX} from "react/jsx-runtime";
import AppButton from "../../../element/button/AppButton";
import moment from "moment/moment";
import {phpToMomentDateFormat} from "../../../../ts/common/SiteHelper";

const AccountPage = (props:IRouteProps) =>
{

    const accountRouteModel = getManager().navigation.model.routeModels.account;

    const viewState = StateViewController({
        routeProps: props,
        assert: accountRouteModel
    })

    if(viewState.overrideView){
        return viewState.overrideView;
    }

    assert(accountRouteModel);

    return <>
        <section className="content-block">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <ul className="vertical-icons mt-4">

                            <li><strong>Name:</strong>{nbsp}{getManager().user.profile.firstName} {getManager().user.profile.lastName}</li>
                            <li><strong>Email address:</strong>{nbsp}{getManager().user.profile.email}</li>

                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <NavRelatedPagesView
            routeProps={props}
            title={"Manage your account"}
        />
    </>
}

export default AccountPage;

